import React from "react";

import Image from "../image";

type Props = {
  size: number;
  customer?: Record<string, any>;
  avatar?: string;
  fullName?: string;
  description?: string;
  showMeta?: boolean;
  avatarBgClassName?: string;
  avatarTextClassName?: string;
}

export default class Avatar extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    showMeta: true,
    avatarBgClassName: "bg-gray-500",
    avatarTextClassName: "text-white",
  };

  getAuthorInitials = (fullName: string) => {
    if (!fullName) return "";
    const nameParts = fullName.split(' ');
    const initials = nameParts
      .filter(Boolean)
      .slice(0, 2)
      .map(namePart => namePart.charAt(0).toUpperCase())
      .join('');

    return initials;
  }

  getCustomerAvatar = (customer: Record<string, any>) => {
    if (!customer) return "";
    const avatar = customer.avatar || customer.Avatar || customer.avatarUrl || customer.avatar_url || customer.profileImage;
    if (!avatar) return "";
    if (typeof avatar === "string") return avatar;
    if (typeof avatar === "object") return avatar.imageFile || avatar.url || avatar.src || "";
    return "";
  }

  getCustomerDisplayName = (customer: Record<string, any>) => {
    if (!customer) return "";
    const firstName = customer.firstName || customer.FirstName || "";
    const lastName = customer.lastName || customer.LastName || "";
    const fullName = customer.name || customer.Name || `${firstName} ${lastName}`.trim();
    if (fullName) return fullName;
    const email = customer.email || customer.EmailAddress || "";
    if (typeof email === "string" && email.length > 0) return email;
    return "";
  }

  render() {
    const { size, customer, description = "", showMeta, avatarBgClassName, avatarTextClassName } = this.props;
    const fullName = this.props.fullName || this.getCustomerDisplayName(customer || {});
    const avatar = this.props.avatar || this.getCustomerAvatar(customer || {});
    if (!avatar && !fullName) return null;
    const avatarNode = avatar
      ? <Image className={`h-${size} w-${size} rounded-full bg-gray-50`} src={avatar} alt="" backgroundColor={null} imgStyle={null} />
      : <span className={`inline-flex h-${size} w-${size} items-center justify-center rounded-full ${avatarBgClassName}`}>
        <span className={`text-sm font-medium leading-none ${avatarTextClassName}`}>{this.getAuthorInitials(fullName)}</span>
      </span>;

    if (!showMeta) return avatarNode;

    return (
      <figcaption className="flex items-center sm:flex-row gap-2 py-4 border-t border-t-[#EAEAF2]">
        {avatarNode}
        <div className="flex flex-col gap-2">
          <div className="generalTextBold">{fullName}</div>
          <div className="caption">{description}</div>
        </div>
      </figcaption>
    )
  }
}